// extracted by mini-css-extract-plugin
module.exports = {"container":"import-modal_container__k_QPp","tips":"import-modal_tips__3cYGD"};